// The `dictation/custom-vocabulary` api module — the CRUD transport behind the
// Dictate "Custom vocab" tab (SCR-3728). Four routes on ml-scribe under
// `/dictation/custom-vocabulary` (list / create / replace-by-id / delete-by-id)
// persisted on the user's `dictation` subdocument.
//
// The transport is the app's REAL `scribeHttpV2` singleton — same interceptors,
// same auth/refresh state — so request behaviour matches `api/preferences.ts`.
// `ScribeHttp` keeps the signatures structural: no axios type reaches this
// package's surface, and `axios` stays out of its manifest.
import { getScribeHttpClients } from '@heidi/api/client';

import type {
  CustomVocabularyEntry,
  CustomVocabularyEntryInput,
  CustomVocabularyResponse,
} from '../../contracts';

interface ScribeHttp {
  get<T>(url: string): Promise<{ data: T }>;
  post<T>(url: string, body?: unknown): Promise<{ data: T }>;
  patch<T>(url: string, body?: unknown): Promise<{ data: T }>;
  delete<T>(url: string): Promise<{ data: T }>;
}

// `scribeHttpV2` base is /api/v2/ml-scribe/; scribe JWT injected by interceptor.
const http = (): ScribeHttp => getScribeHttpClients().scribeHttpV2;
const BASE = '/dictation/custom-vocabulary';

export const getCustomVocabulary = async () => {
  const response = await http().get<CustomVocabularyResponse>(BASE);
  return response.data;
};

export const createCustomVocabularyEntry = async (input: CustomVocabularyEntryInput) => {
  const response = await http().post<CustomVocabularyEntry>(BASE, input);
  return response.data;
};

export const updateCustomVocabularyEntry = async (
  id: string,
  input: CustomVocabularyEntryInput
) => {
  const response = await http().patch<CustomVocabularyEntry>(`${BASE}/${id}`, input);
  return response.data;
};

export const deleteCustomVocabularyEntry = async (id: string): Promise<void> => {
  await http().delete<void>(`${BASE}/${id}`);
};
